<template>
  <div class="product__modal" @click.stop="emit('toggle-uc-ship-modal')">
    <div class="product__content" @click.stop>
      <div class="product__content-exit icon icon--xs" @click.stop="emit('toggle-uc-ship-modal')">
        <svg><use href="#exit"></use></svg>
      </div>
      <div class="text-component">
        <h3>Sign In to Your Account</h3>
      </div>
      <div class="form-wrapper">
        <form @submit.prevent="submitForm">
          <input type="hidden" name="form_type" value="customer_login" autocomplete="off" />
          <input type="hidden" name="utf8" value="✓" autocomplete="off" />
  
          <div class="upcoming__shipment-body">
            <div class="form-line form-line--float-label">
              <input v-model="email" class="form-input" type="email" name="customer[email]" placeholder="Your email address" required />
            </div>
            <div class="form-line form-line--float-label">
              <input v-model="password" class="form-input" type="password" name="customer[password]" placeholder="Your password" required />
            </div>
            <div class="form-actions">
              <button
                :disabled="isFormSubmitting"
                class="btn btn--primary"
                type="submit">
                <span v-if="!isFormSubmitting">Sign In</span>
                <span v-else>Signing In..</span>
              </button>
              <p>Don't have an account? <a href="/account/register">Register</a></p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';

  const email = ref('');
  const password = ref('')
  const emit = defineEmits(['toggle-uc-ship-modal'])
  const isFormSubmitting = ref(false);

  const submitForm = async() => {
    isFormSubmitting.value = true;
    try {
      const response = await fetch('/account/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({
          form_type: 'customer_login',
          utf8: '✓',
          'customer[email]': email.value,
          'customer[password]': password.value
        }).toString()
      });

      const responseText = await response.text();

      if (response.ok) {
        if (responseText.includes('Incorrect email or password.')) {
          emit('toggle-uc-ship-modal');
          window.location.href = '/account/login';
          isFormSubmitting.value = false;
        } else {
          emit('toggle-uc-ship-modal');
          window.location.reload();
          isFormSubmitting.value = false;
        }
      } else {
        emit('toggle-uc-ship-modal');
        window.location.href = '/account/login';
        isFormSubmitting.value = false;
      }
    } catch (error) {
      isFormSubmitting.value = false;
      emit('toggle-uc-ship-modal');
      console.error('Error during form submission:', error);
    }
  }
</script>